<template>
  <form-block
    :title="tr('Members to be notified about activities')"
    :description="description"
  >
    <multi-select
      v-model="insideValue"
      :options="companyMemberOptions"
      :placeholder="tr('Search member')"
      :disabled="disabled || isLoading"
      :loading="userListIsLoading"
      label-key="fullname"
      value-key="id"
    />
  </form-block>
</template>

<script>
import CompanyMemberListMixin from '@/mixins/CompanyMemberList.js';
import RuleFormBlockMixin from '@/mixins/RuleForm/Block.js';
import MultiSelect from '@/ui/components/MultiSelect.vue';

export default {
  name: 'NotifiableUsersBlock',
  components: {
    MultiSelect,
  },
  mixins: [ CompanyMemberListMixin, RuleFormBlockMixin ],
  data: () => ({
    insideValue: [],
  }),
  computed: {
    isLoading() {
      return this.userListIsLoading;
    },
    description() {
      if (this.entity.action === 'stop') {
        return this.tr('The selected individuals will receive email notifications when an advertisement stops based on the configured rule.');
      }

      return this.tr('The selected individuals will receive email notifications when an advertisement starts based on the configured rule.');
    },
  },
  watch: {
    isLoading(val) {
      if (!val) {
        this.insideValue = this.entity.notifiable_users.map(user => user.id);
      }
    },
    value(val) {
      if (val && !this.isLoading) {
        const currentIds1 = JSON.parse(JSON.stringify(this.insideValue)).sort();
        const currentIds2 = this.entity.notifiable_users.map(user => user.id).sort();

        if (JSON.stringify(currentIds1) !== JSON.stringify(currentIds2)) {
          this.insideValue = this.entity.notifiable_users.map(user => user.id);
        }
      }
    },
    insideValue(val) {
      if (!this.isLoading) {
        const currentIds1 = JSON.parse(JSON.stringify(this.insideValue)).sort();
        const currentIds2 = this.entity.notifiable_users.map(user => user.id).sort();

        if (JSON.stringify(currentIds1) !== JSON.stringify(currentIds2)) {
          const newValue = val.map(userId => this.companyMemberOptions.find(user => user.id === userId));
          this.entity.notifiable_users = newValue;
        }
      }
    },
  },
  methods: {
    validate() {
      return this.validateSelectedUsers(this.insideValue);
    },
  },
};
</script>
